












































































import {
  defineComponent,
  reactive,
  ref,
  toRefs,
  onBeforeMount,
  inject,
} from '@vue/composition-api'

import { signUpUser, userInfoFromCode } from '@/shared/api'
import { alertSymbol } from '@/shared/state-management/symbols'

export default defineComponent({
  name: 'Register',
  components: {},
  setup(props, { root }) {
    const $alert = inject(alertSymbol) as Function
    const data = reactive({
      valid: true,
      firstname: '',
      lastname: '',
      email: '',
      password: '',
      passwordConfirm: '',
    })

    const rules = reactive({
      passwordConfirmRules: [
        (v: string) => {
          return (
            v === data.password || root.$t('register.passwordConfirmnvalid')
          )
        },
      ],
      passwordRules: [
        (v: string) =>
          (!!v && v.length >= 8) || root.$t('login.password.invalid_length'),
        (v: string) => {
          const result = v.match(/^.*(?=\S*[\W]).*$/)
          return (
            (result && result.length && result[0] !== '') ||
            root.$t('login.password.specialCharacter')
          )
        },
      ],
    })

    const code = ref('')
    const signUpUserForm = ref(null)
    const loading = ref(false)
    const loadingUserInfo = ref(false)
    const error = ref(false)

    onBeforeMount(async () => {
      code.value = root.$route.query.code as string
      try {
        loadingUserInfo.value = true
        const userInfo = await userInfoFromCode(code.value)
        data.firstname = userInfo.firstname
        data.lastname = userInfo.lastname
        data.email = userInfo.email
        loadingUserInfo.value = false
      } catch (e) {
        loadingUserInfo.value = false
        error.value = true
        throw e
      }
    })

    const submit = async (event: Event) => {
      event.preventDefault()
      event.stopPropagation()
      const form = signUpUserForm.value
      form.validate()
      if (!data.valid) {
        return
      }
      loading.value = true
      try {
        await signUpUser(
          code.value,
          data.email,
          data.password,
          data.firstname,
          data.lastname
        )
        loading.value = false
        $alert({ type: 'success', text: root.$t('register.success') })
        root.$router.push({ name: 'Login', params: { email: data.email } })
      } catch (e) {
        loading.value = false
        throw e
      }
    }

    return {
      ...toRefs(data),
      ...toRefs(rules),
      code,
      signUpUserForm,
      submit,
      loading,
      loadingUserInfo,
      error,
    }
  },
})
